import $ from "jquery";

// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from '/node_modules/swiper';
// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay]);

// import Swiper and modules styles


$(function () {

    $.fn.sliderAcfProgramme = function () {

        new Swiper(this[0], {
            slidesPerView: 1.2,
            spaceBetween: 21,
            centeredSlides: true,
            loop: true,
            observer: true,
            observeParents: true,

            autoplay: {
                delay: 5000,
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },

            navigation: {
                nextEl: this.parent().find('.swiper-button-next')[0], //this.parent().find('.swiper-button-next')[0], //".swiper-button-next",
                prevEl: this.parent().find('.swiper-button-prev')[0], //".swiper-button-prev",
            },

            breakpoints: {
                993: {
                    slidesPerView: 3,
                    centeredSlides: false,
                 
                },
                768: { // à partir de 768px
                    slidesPerView: 2,
                    spaceBetween: 24,
                    pagination: false,
                    centeredSlides: false,
                },
            },
        });
    };

});